var qs = require("querystring");
var X = require("./x");
var Info = require("./info");
var SelectBox = require("./select");

// tooltips
var infos = document.getElementsByClassName("info");
for(var i = 0; i < infos.length; ++i) {
  Info(infos[i], infos[i].innerHTML, {
    className: "info-tooltip",
    arrowClassName: "info-tooltip-arrow",
    wrapperClassName: "info-tooltip-wrapper",
    offsetX: 0,
    offsetY: 3
  });
}

// "dynamic" signup
var query = qs.parse(document.location.search.substr(1));
if(query.service) {
  var printType = document.querySelector(".form-page-layout3.form-page-check");
  var infoPayment = document.querySelectorAll(
      ".form-page.form-page-right:not(.form-page-check) h5");
  var payment = null;

  if(query.service === "Kiosk") {
    printType.querySelector(".form-check").className =
        "form-check form-check-disabled";
    printType.querySelector("input[type='checkbox']").disabled = "disabled";
  } else if(query.service === "Business") {
    printType.querySelector(".form-text").style.display = "none";
    printType.querySelector("label").innerHTML = "Abo - BSZ / Staatsanzeiger";

    for(var i = 0, h5; i < infoPayment.length; ++i) {
      h5 = infoPayment[i];
      if(X.getCSSProperty(h5, "display") !== "none") {
        h5.parentNode.parentNode.style.display = "none";
        payment = X.findElementInSameParent("next", h5.parentNode.parentNode);
        break;
      }
    }
  } else {
    document.location.href = "index.html";
  }
}

// only use select.js when IE < 10
if(document.all && !window.atob) {
  var select = document.getElementsByTagName("select");
  for(var i = 0; i < select.length; ++i) {
    SelectBox(select[i]);
  }
}

// parsely
if(document.querySelectorAll(".powermail_form").length > 0) {
  var checkForParsley = setInterval(function() {
    if("Parsley" in window && "jQuery" in window) {
      clearInterval(checkForParsley);

      var parsleyForm = jQuery("form").parsley({
        errorClass: "form-error",
        classHandler: function(pf) {
          return pf.$element.parent();
        }
      });
      jQuery("form").submit(function(event) {
        var test = parsleyForm.validate();
        if(!test) {
          event.preventDefault();
          return false;
        }
      });
    }
  }, 100);
}
